<script>

    export let inputType = 'text';
    export let name = '';
    export let id = '';
    export let value = '';
    export let classes = ' rpgui-dropdown-imp rpgui-dropdown-imp-header ';
    export let placeholder = '';
    export let label = '';
    export let autocomplete = false;

    export let required = false;
    export let error = null;
    export let disabled = false;
    export let hidden = false;

    let allowed = ['text', 'number', 'password'];
    const tp = allowed.includes(inputType) ? inputType : 'text';

    let lbl = label === false ? false: ( label == '' ? name : label );

    let requiredHtml = required ? ' <span class="text-danger">*</span>': '';

</script>

<div class="form-group_rpgui" hidden="{hidden}">
	
    {#if lbl !== false }
        <label for="{name}"> {lbl} {@html requiredHtml}</label>
    {/if}

    {#if tp == 'number'}
        <input autocomplete="{ autocomplete === true ? 'on': 'off'}" type="number" class="{classes}" class:is-invalid="{error}" placeholder="{placeholder}" name="{name}" id="{id}"  bind:value="{value}" disabled="{disabled}"  >
    {:else if tp == 'password'}
        <input autocomplete="{ autocomplete === true ? 'on': 'off'}" type="password" class="{classes}" class:is-invalid="{error}" placeholder="{placeholder}" name="{name}" id="{id}"  bind:value="{value}" disabled="{disabled}"  >
    {:else}
        <input autocomplete="{ autocomplete === true ? 'on': 'off'}" type="text" class="{classes}" class:is-invalid="{error}" placeholder="{placeholder}" name="{name}" id="{id}"  bind:value="{value}" disabled="{disabled}"  >
    {/if}

    {#if error }
        <span class="rpgui_input-invalid" style="color:#ff0000;">
            <strong>{@html Array.isArray(error) ? error.join('<br>') : error }</strong>
        </span>
    {/if}

</div>

<style>
/* .form-group_rpgui {

} */
.form-group_rpgui.is-invalid {
    background-color: #ff0000;
    column-rule: #fafafa;

}

.form-group_rpgui input {
    background-color:#7d4e35
}

.rpgui_input-invalid {
    color: #ff0000;
}

</style>